import {
  Box,
  Button,
  Checkbox,
  GRangeFilterPrice,
  HStack,
  Text,
} from '@gazin/ecommerce-ui'
import { FormEventHandler, useState } from 'react'
import {
  Filter,
  SelectedFiltersByLinx,
  Value,
} from 'src/services/linx-api/dtos'
import { FilterProduct as FiltersProductProps } from '../../templates/SearchAndCategory'
import { Accordion } from '../accordion'
import { getFilteredPrice, minimumAndMaximumPrice } from 'src/util/products'

export type RemoveFilter = {
  id_atributo: number
  label: string
}

type FilterProductProps = {
  filter: Filter
  keyFilter: number
  removeFilter: ({ id_atributo, label }: RemoveFilter) => void
  selectedFilterByLinx?: SelectedFiltersByLinx[]
  selectFilter({
    attribute,
    id_atributo,
    id_valor_unidade,
    label,
    tipo,
    valor_maximo,
    valor_minimo,
    queryFiltro,
  }: FiltersProductProps): void
}

export default function FilterProduct({
  filter,
  keyFilter,
  removeFilter,
  selectedFilterByLinx,
  selectFilter,
}: FilterProductProps) {
  const [showMore, setShowMore] = useState(false)

  function resetScroll() {
    const filterScroll = document.querySelector(`.filter-scroll-${keyFilter}`)

    filterScroll?.scroll(0, 0)
  }

  const filteredPrice = getFilteredPrice(selectedFilterByLinx)

  const handleClick = (item: Value) => {
    const itemToRemove = {
      id_atributo: Number(item?.id) ?? Number(item?.unityId),
      label: String(item?.label),
    }

    item.selected
      ? removeFilter(itemToRemove)
      : selectFilter({
          attribute: filter.attribute,
          id_atributo: filter.id,
          id_valor_unidade: Number(item?.id) ?? Number(item.unityId),
          label:
            item?.label?.normalize('NFD').replace(/[\u0300-\u036f]/g, '') ?? '',
          tipo: filter.type,
          valor_maximo: item?.max?.value,
          valor_minimo: item?.min?.value,
        })
  }

  return (
    <>
      <Box
        alignItems="flex-start"
        justifyContent="space-between"
        w="100%"
        h="100%"
        key={keyFilter}
      >
        <Accordion.Item title={filter?.attribute}>
          {filter?.attribute === 'Preço' ? (
            <Box w="95%" margin="0 auto">
              <GRangeFilterPrice
                minimumPrice={
                  filteredPrice?.min ||
                  minimumAndMaximumPrice(filter.values).min
                }
                maximumPrice={
                  filteredPrice?.max ||
                  minimumAndMaximumPrice(filter.values).max
                }
                onChange={
                  ((minimum, maximum) => {
                    filter?.attribute === 'Preço' &&
                      filter?.values?.map((item: any) =>
                        selectFilter({
                          id_atributo: filter?.id,
                          id_valor_unidade: item?.id ?? item?.unityId,
                          tipo: filter.type,
                          valor_minimo: minimum,
                          valor_maximo: maximum,
                          attribute: filter.attribute,
                          label: item?.label ?? '',
                        })
                      )
                  }) as ((minimum: number, maximum: number) => void) &
                    FormEventHandler<HTMLDivElement>
                }
                css={`
                  p {
                    display: none;
                  }
                `}
              />
            </Box>
          ) : (
            <>
              <Box
                maxH="7.5rem"
                h="100%"
                overflow={`${showMore ? 'auto' : 'hidden'}`}
                css={`
                  &::-webkit-scrollbar {
                    width: 0.375rem;
                  }

                  &::-webkit-scrollbar-thumb {
                    background-color: rgba(176, 179, 192, 0.5);
                    border-radius: 20px;
                  }
                `}
                className={`filter-scroll-${keyFilter}`}
              >
                {filter?.values?.map((item) => (
                  <HStack
                    alignItems="center"
                    justifyContent="space-between"
                    key={item.id}
                  >
                    <HStack>
                      <Checkbox
                        borderColor="neutral.200"
                        onChange={() => handleClick(item)}
                        isChecked={item?.selected}
                      />
                      <Text
                        color="neutral.600"
                        fontSize="0.875rem"
                        lineHeight="1.5rem"
                        fontFamily="body"
                      >
                        {item?.label}
                      </Text>
                    </HStack>
                    <Text fontSize="0.875rem" color="neutral.400">
                      ({item?.size})
                    </Text>
                  </HStack>
                ))}
              </Box>
              <Button
                variant="ghost"
                color="primary.500"
                fontSize="0.875rem"
                mt="1rem"
                fontWeight="600"
                lineHeight="1.05rem"
                _hover={{ bg: 'transparent' }}
                h="fit-content"
                px={0}
                alignItems="flex-start"
                justifyContent="flex-start"
                display={`${filter?.values?.length > 5 ? 'flex' : 'none'}`}
                onClick={() => {
                  resetScroll()
                  setShowMore(!showMore)
                }}
              >
                {showMore ? 'Ver menos' : 'Ver tudo'}
              </Button>
            </>
          )}
        </Accordion.Item>
      </Box>
    </>
  )
}
